export default "/img/header_small_1202.png";